import styled from "styled-components";

const ListHeading = styled.h4`
  color: #ccc;
  font-size:2rem; 

  margin-bottom: 1rem ;
  margin-top: 3rem;
`;

export default ListHeading;
